export default {
  seeMoreText: 'See More',
};
